export const ONGOING = 'ongoing'
export const ON_HOLD = 'on_hold'
export const COMPLETED = 'completed'

// Allowed status transitions. A project starts Ongoing. Ongoing/On Hold may move
// between each other or to Completed. Completed is terminal — no outgoing moves.
export const ALLOWED_TRANSITIONS = {
    [ONGOING]: [ON_HOLD, COMPLETED],
    [ON_HOLD]: [ONGOING, COMPLETED],
    [COMPLETED]: [],
}

export const canTransition = (from, to) =>
    (ALLOWED_TRANSITIONS[from] || []).includes(to)
